/**
 * Contacts surface (live) - the tag-picker match predicate for the Upload flow.
 * The Upload flow parses the real dropped file (csv-parse.ts) and runs the
 * seniority/function selection against those parsed rows. Matching uses the SAME
 * title-inference rules as the page's Seniority and Function filters. (There is
 * no sample fallback on the live surface: an unparseable file falls back to
 * importing the whole file server-side, never to fabricated rows.)
 */

import { inferFunction, inferSeniority } from "./derive";
import type { FunctionArea, Seniority } from "./derive";

/** A parsed row matches the picker when its inferred seniority is in the chosen
 *  set (or none chosen) AND its inferred function is in the chosen set (or none
 *  chosen). Empty selections match everything, so the step stays skippable. */
export function rowMatches(
  title: string,
  seniority: Seniority[],
  functions: FunctionArea[],
): boolean {
  const okSeniority =
    seniority.length === 0 || seniority.includes(inferSeniority(title));
  const okFunction =
    functions.length === 0 || functions.includes(inferFunction(title));
  return okSeniority && okFunction;
}
